import { Skeleton } from "@mui/material";
import classNames from "classnames";
import styles from "./style.module.scss";

function SchoolDetailHeaderSkeleton({ className }: { className?: string }) {
  return (
    <div className={classNames(styles.wrap, className)}>
      <Skeleton variant="text" width={110} height={20} />
      <div className={styles.identity}>
        <Skeleton variant="text" width={250} height={32} />
        <Skeleton
          variant="rounded"
          width={76}
          height={22}
          sx={{ borderRadius: "16px" }}
        />
        <Skeleton variant="text" width={175} height={20} />
      </div>
    </div>
  );
}

export default SchoolDetailHeaderSkeleton;
